export const getShipmentCost = async (apiInstance, clientPriceListId) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/GetShipmentCost?clientPriceListId=${clientPriceListId}`,
    requestParameters
  )
}

export const addShipmentCost = async (apiInstance, data, shipmentCost) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/AddShipmentCost?shipmentCost=${shipmentCost}`,
    requestParameters
  )
}

export const deliveryTime = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(`${apiInstance.apiURL}/DeliveryTime`, requestParameters)
}

export const sendShippingMethod = async (
  apiInstance,
  clientId,
  method,
  address,
  date,
  data
) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/ChangeSelectedShippingMethod/${clientId}/${method}/${address}?pickingDate=${date}`,
    requestParameters
  )
}

export const getPaymentMethods = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/PaymentConditions/GetPaymentConditions`,
    requestParameters
  )
}

export const getBanks = async (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(
    `${apiInstance.apiURL}/PaymentConditions/GetBanks`,
    requestParameters
  )
}

export const sendPaymentMethod = (apiInstance, id, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(
    `${apiInstance.apiURL}/Cart/ChangeSelectedPaymentType?clientId=${id}`,
    requestParameters
  )
}

export const confirmOrder = async (apiInstance, data) => {
  let requestParameters = {
    method: 'POST',
    mode: 'cors',
    headers: apiInstance.headers,
    body: JSON.stringify(data)
  }

  return fetch(`${apiInstance.apiURL}/Cart/Checkout`, requestParameters)
}
